import { ShowSpeechFeedback } from './feedback.d';
import state from '@state';

/**
 * Displays a temporary feedback message inside the voice button.
 */
export const showSpeechFeedback: ShowSpeechFeedback = (message, type = 'info') => {
	let voiceButton = null;

	if (state.currentInstance?.searchContainer) {
		voiceButton = document.querySelector<HTMLElement>(`${state.currentInstance?.searchContainer} .aex-voice-button`);
	} else {
		voiceButton = document.querySelector<HTMLElement>(`${state.currentInstance?.searchForm} .aex-voice-button`);
	}
	if (!voiceButton) {
		return;
	}

	// Create or update feedback element
	let feedback = voiceButton?.parentElement?.querySelector('.aex-speech-feedback') as HTMLElement | null;

	if (!feedback) {
		feedback = document.createElement('p');
		feedback.setAttribute('role', 'status');
		feedback.className = 'aex-speech-feedback';
		feedback.classList.add('visually-hidden');
		voiceButton.insertAdjacentElement('afterend', feedback);
	}

	feedback.classList.remove('info', 'warning', 'error');
	feedback.classList.add(type);
	feedback.textContent = message;
};
